// App.js
import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Mission from './components/Mission';
import Industries from './components/Industries';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BusinessReportForm from './pages/BusinessReportForm';
import BookStrategySession from './pages/BookStrategySession';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import RefundCancellationPolicyPage from './pages/RefundCancellationPolicyPage';
import DisclaimerPage from './pages/DisclaimerPage';
import './App.css';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');
  const [prefillData, setPrefillData] = useState({});

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setScrolled(window.scrollY > 50);
          
          const sections = document.querySelectorAll('.fade-in-section');
          sections.forEach(section => {
            const rect = section.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.8) {
              section.classList.add('visible');
            }
          });
          
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigateToForm = () => {
    setCurrentPage('form');
  };

  const navigateToBooking = (formData = {}) => {
    setPrefillData(formData);
    setCurrentPage('booking');
  };

  const navigateToHome = () => {
    setCurrentPage('home');
    setPrefillData({});
  };

  const navigateToPage = (page) => {
    setCurrentPage(page);
  };

  // Handle policy pages
  if (currentPage === 'privacy-policy') {
    return <PrivacyPolicyPage onBack={navigateToHome} />;
  }

  if (currentPage === 'terms-conditions') {
    return <TermsConditionsPage onBack={navigateToHome} />;
  }

  if (currentPage === 'cookie-policy') {
    return <CookiePolicyPage onBack={navigateToHome} />;
  }

  if (currentPage === 'refund-policy') {
    return <RefundCancellationPolicyPage onBack={navigateToHome} />;
  }

  if (currentPage === 'disclaimer') {
    return <DisclaimerPage onBack={navigateToHome} />;
  }

  if (currentPage === 'form') {
    return (
      <BusinessReportForm 
        onBack={navigateToHome} 
        onNavigateToBooking={navigateToBooking}
      />
    );
  }

  if (currentPage === 'booking') {
    return (
      <BookStrategySession 
        onBack={navigateToHome} 
        prefillData={prefillData}
      />
    );
  }

  return (
    <div className="App">
      <Navbar scrolled={scrolled} onNavigateToForm={navigateToForm} />
      <main>
        <section id="home">
          <Hero onNavigateToForm={navigateToForm} onNavigateToBooking={navigateToBooking} />
        </section>
        <section id="about" className="fade-in-section">
          <About />
        </section>
        <section id="services" className="fade-in-section">
          <Services />
        </section>
        <section id="how-it-works" className="fade-in-section">
          <HowItWorks />
        </section>
        <section id="mission" className="fade-in-section">
          <Mission />
        </section>
        <section id="industries" className="fade-in-section">
          <Industries />
        </section>
        <section id="testimonials" className="fade-in-section">
          <Testimonials />
        </section>
        <section id="pricing" className="fade-in-section">
          <Pricing />
        </section>
        <section id="contact" className="fade-in-section">
          <Contact />
        </section>
      </main>
      <Footer onNavigateToPage={navigateToPage} />
    </div>
  );
}

export default App;